import React, { Component } from 'react';
import {store} from 'Store/store.index';
import './index.scss';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Select, Radio, InputNumber, Button } from 'antd';
import ModalDrag from '../DragDialog/index';
import intl from 'react-intl-universal';
export default class PageTransitionsDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            transitionVal: 'NoTransition',
            directionVal: '',
            speedVal: '',
            transitionOption: {
                'NoTransition': [],
                'Split': [
                    'Horizontal Inward',
                    'Horizontal Outward',
                    'Vertical Inward',
                    'Vertical Outward'
                ],
                'Blinds': [
                    'Horizontal',
                    'Vertical'
                ],
                'Box': [
                    'Inward',
                    'Outward'
                ],
                'Wipe': [
                    'Right',
                    'Right Up',
                    'Up',
                    'Left Up',
                    'Left',
                    'Left Down',
                    'Down',
                    'Right Down'
                ],
                'Dissolve': [],
                'Glitter': [
                    'Right',
                    'Right Up',
                    'Up',
                    'Left Up',
                    'Left',
                    'Left Down',
                    'Down',
                    'Right Down'
                ],
                'Push': [
                    'Right',
                    'Up',
                    'Left',
                    'Down',
                ],
                'Cover': [
                    'Right',
                    'Right Up',
                    'Up',
                    'Left Up',
                    'Left',
                    'Left Down',
                    'Down',
                    'Right Down'
                ],
                'Uncover': [
                    'Right',
                    'Right Up',
                    'Up',
                    'Left Up',
                    'Left',
                    'Left Down',
                    'Down',
                    'Right Down'
                ],
                'Fade': [],
                'Replace': [],
                'Fly': [
                    'Right',
                    'Up',
                    'Left',
                    'Down',
                ]
            },
            directionOption: [],
            speedOption: [
                'Slow',
                'Medium',
                'Fast'
            ],
            pageRangeSelected: 0,
            from: 1,
            to: 1,
            pageCount: 1
        };
    }
    showDialog = (data) => {
        console.log("showDialog")
        const currentPDFDoc = window.pdfui.pdfViewer.currentPDFDoc;
        window.pdfui.getComponentByName('fv-thumbnail-panel').then(async component => {
            this.thumbnailComponent = component;
            let pages = this.thumbnailComponent.getAllActivePageIndex()[0];
            let page = 1;
            if (pages.length === 1) {
                page = pages[0][pages[0].length -1]
            } else {
                page = pages[pages.length -1][pages[pages.length -1].length -1]
            }
            const {
                transName,
                direction,
                speed
            } = await currentPDFDoc.getPageTransitionByIndex(page - 1);
            this.setState({
                key: Math.random(),
                pageRangeSelected: 0,
                visible: true,
                transitionVal: transName,
                directionOption: this.state.transitionOption[transName],
                directionVal: direction,
                speedVal: speed,
                pageCount: data.docInfo.docPageCount,
                from: page,
                to: page,
            });
        });
    }
    handleCancel = () => {
        this.setState({ visible: false });
    }
    handleOk = async () => {
        const currentPDFDoc = window.pdfui.pdfViewer.currentPDFDoc;
        const {
            transitionVal,
            directionVal,
            speedVal,
            pageRangeSelected,
            pageCount,
            from,
            to
        } = this.state;
        let pages = this.thumbnailComponent.getAllActivePageIndex()[0];
        let range = [];
        if (pageRangeSelected === 0) {
            range = pages;
        } else if (pageRangeSelected === 1) {
            range =[[1, pageCount]];
        } else if (pageRangeSelected === 2) {
            const min = Math.min(from, to);
            const max = Math.max(from, to);
            range = [[min, max]];
        }
        const state = await currentPDFDoc.setPageTransition(transitionVal, directionVal, speedVal, range);
        if (state) {
            store.appStore.doUpdateDocModified(true);
            this.setState({ visible: false });
        }
    }
    handleChangeTransition = (val) => {
        this.setState({
            transitionVal: val,
            directionOption: this.state.transitionOption[val],
            directionVal: this.state.transitionOption[val][0],
            speedVal: val === 'noTransition' ? '' : this.state.speedOption[0]
        });
    }
    handleChangeDirection = (val) => {
        this.setState({
            directionVal: val
        });
    }
    handleChangeSpeedOption = (val) => {
        this.setState({
            speedVal: val
        });
    }
    onChangePageRangeSelected = (e) => {
        this.setState({
            pageRangeSelected: e.target.value
        });
    }
    onChangeFrom = (val) => {
        this.setState({
            from: val
        });
    }
    onChangeTo = (val) => {
        this.setState({
            to: val
        });
    }
    render() {
        const {
            visible,
            transitionVal,
            directionVal,
            speedVal,
            transitionOption,
            directionOption,
            speedOption,
            pageRangeSelected,
            pageCount,
            from,
            to,
            key
        } = this.state;
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        const title = <ModalDrag title={ intl.formatMessage({ id: 'pageTransitionsDialog.title' }) } />
        const pageTransitionTitle = intl.formatMessage({ id: 'pageTransitionsDialog.pageTransition' });
        const transitionLabel = intl.formatMessage({ id: 'pageTransitionsDialog.transition.title' });
        const directionLabel = intl.formatMessage({ id: 'pageTransitionsDialog.direction.title' });
        const speedLabel = intl.formatMessage({ id: 'pageTransitionsDialog.speed.title' });
        const pageRangeTitle = intl.formatMessage({ id: 'pageTransitionsDialog.pageRange' });
        function transitionOptionFn() {
            return (
                Object.keys(transitionOption).map(item => {
                    return (
                        <Select.Option
                            key={item}
                            value={item}>
                                { intl.formatMessage({ id: `pageTransitionsDialog.transition.${item}` }) }
                        </Select.Option>
                    );
                })
            );
        }
        function directionOptionFn() {
            return (
                directionOption.map(item => {
                    return (
                        <Select.Option
                            key={item}
                            value={item}>
                                { intl.formatMessage({ id: `pageTransitionsDialog.direction.${item}` }) }
                        </Select.Option>
                    );
                })
            );
        }
        function speedOptionFn() {
            return (
                speedOption.map(item => {
                    return (
                        <Select.Option
                            key={item}
                            value={item}>
                                { intl.formatMessage({ id: `pageTransitionsDialog.speed.${item}` }) }
                        </Select.Option>
                    );
                })
            );
        }
        const footer = [
            <Button  key="cancel" onClick={this.handleCancel}>{intl.formatMessage({ id: 'pageTransitionsDialog.cancel' })}</Button>,
            <Button  key="ok" type="primary" onClick={this.handleOk}>{intl.formatMessage({ id: 'pageTransitionsDialog.ok' })}</Button>
        ]
        return (
            <Modal
                key={key}
                className="page-transitions-dialog"
                title={title}
                visible={visible}
                onCancel={this.handleCancel}
                footer={footer}
                width={450}>
                    <div className="content">
                        <div className="page-transition">
                            <span className="title">{ pageTransitionTitle }</span>
                            <div className="item">
                                <Form labelCol={{ span: 6, }} wrapperCol={{ span: 12, offset: 1 }}>
                                    <Form.Item label={transitionLabel}>
                                        <Select
                                            size="small"
                                            defaultValue={transitionVal}
                                            onChange={this.handleChangeTransition}>
                                            {transitionOptionFn()}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item label={directionLabel}>
                                        <Select
                                            size="small"
                                            value={directionVal}
                                            disabled={!directionOption.length}
                                            onChange={this.handleChangeDirection}>
                                            {directionOptionFn()}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item label={speedLabel}>
                                        <Select
                                            size="small"
                                            value={speedVal}
                                            disabled={transitionVal === 'NoTransition'}
                                            onChange={this.handleChangeSpeedOption}>
                                            {speedOptionFn()}
                                        </Select>
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                        <div className="page-range">
                            <span className="title">{ pageRangeTitle }</span>
                            <div className="item">
                                <Radio.Group onChange={this.onChangePageRangeSelected} value={pageRangeSelected}>
                                    <Radio style={radioStyle} value={0}>
                                        {intl.formatMessage({ id: 'pageTransitionsDialog.selectedPages' })}
                                    </Radio>
                                    <Radio style={radioStyle} value={1}>
                                        {intl.formatMessage({ id: 'pageTransitionsDialog.allPages' })}
                                    </Radio>
                                    <Radio style={radioStyle} value={2}>
                                        {intl.formatMessage({ id: 'pageTransitionsDialog.pageForm' })}
                                        <InputNumber
                                            style={{ 'margin': '0 8px' }}
                                            size="small"
                                            min={1}
                                            max={pageCount}
                                            defaultValue={from}
                                            disabled={pageRangeSelected !== 2}
                                            onChange={this.onChangeFrom} />
                                        {intl.formatMessage({ id: 'pageTransitionsDialog.to' })}
                                        <InputNumber
                                            style={{ 'margin': '0 8px' }}
                                            size="small"
                                            min={1}
                                            max={pageCount}
                                            defaultValue={to}
                                            disabled={pageRangeSelected !== 2}
                                            onChange={this.onChangeTo} />
                                        {intl.formatMessage({ id: 'pageTransitionsDialog.of' })}
                                        <span style={{"marginLeft": "8px"}}>{pageCount}</span>
                                    </Radio>
                                </Radio.Group>
                            </div>
                        </div>
                    </div>
            </Modal>
        )
    }
}
